
import { useRef, useEffect } from 'react';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import successAnim from '../../assets/Success.json';

type Props = {
  onContinue: () => void;
  autoContinueMs?: number;
  continueDisabled?: boolean;
  buttonLabel?: string;
};

export default function MatchingProfileSuccess({ onContinue, autoContinueMs, continueDisabled, buttonLabel = 'Continue to Bio' }: Props) {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useEffect(() => {
    if (!autoContinueMs) return;
    const id = setTimeout(onContinue, autoContinueMs);
    return () => clearTimeout(id);
  }, [autoContinueMs, onContinue]);

  return (
    <div style={{ display: 'grid', placeItems: 'center', padding: '4rem 1rem' }}>
      <div style={{ width: 100, height: 100 }}>
        <Lottie lottieRef={lottieRef} animationData={successAnim} loop={true} autoplay />
      </div>

      <h2 style={{ marginTop: 24, fontSize: 28, fontWeight: 700 }}>Success!</h2>
      <p style={{ marginTop: 8, color: '#666', textAlign: 'center' }}>
        Your matching profile has been completed.
      </p>

      <button
        onClick={onContinue}
        disabled={continueDisabled}
        style={{
          marginTop: 24,
          padding: '24px 40px',
          borderRadius: 4,
          border: '1px solid #D22268',
          color: '#D22268',
          backgroundColor: continueDisabled ? 'rgba(210,34,104,0.1)' : 'transparent',
          cursor: continueDisabled ? 'not-allowed' : 'pointer',
          fontWeight: 600
        }}
      >
        {buttonLabel}
      </button>
    </div>
  );
}
